import { FormattedMessage } from 'react-intl'
import Panel from '../Panel'
import styles from './EstimatedValuePanelHeading.module.scss'

interface EstimatedValuePanelHeadingProps {
  homeValue: number
}

export const EstimatedValuePanelHeading = ({
  homeValue,
}: EstimatedValuePanelHeadingProps) => {
  return (
    <Panel.Heading className={styles.heading}>
      <FormattedMessage
        id='Homeowner.estimatedValue.headline'
        defaultMessage='The estimated value of your {forceNoWrap}'
        values={{
          forceNoWrap: (
            <span className={styles.forceNoWrap}>
              <FormattedMessage
                id='Homeowner.estimatedValue.headline.force'
                defaultMessage='home is'
              />
            </span>
          ),
        }}
      />
      <span className='screenReaderText'>{'$' + homeValue}</span>
    </Panel.Heading>
  )
}
